import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1743.8579 267.012456L710.746654 1300.1237 176.005086 765.382131 0 941.387217 710.746654 1652.25843 1919.98754 443.142104z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCheckMarkSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCheckMarkSolid, _Component);

  var _super = _createSuper(IconCheckMarkSolid);

  function IconCheckMarkSolid() {
    _classCallCheck(this, IconCheckMarkSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCheckMarkSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCheckMark",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCheckMarkSolid.displayName = "IconCheckMarkSolid";
  return IconCheckMarkSolid;
}(Component);

IconCheckMarkSolid.glyphName = 'check-mark';
IconCheckMarkSolid.variant = 'Solid';
IconCheckMarkSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCheckMarkSolid;
export { IconCheckMarkSolid };